module.exports = __webpack_public_path__ + "static/media/title-bg.f86dd173.png";